export const FILTERS = [
  {
    text: 'Deadline',
    value: 'deadline'
  },
  {
    text: 'JS Task',
    value: 'jsTask'
  },
  {
    text: 'HTML Task',
    value: 'htmlTask'
  },
  {
    text: 'Self Education',
    value: 'selfEducation'
  },
  {
    text: 'External Task',
    value: 'externalTask'
  },
  {
    text: 'Code Wars',
    value: 'codeWars'
  },
  {
    text: 'Code Jam',
    value: 'codeJam'
  },
  {
    text: 'Lecture',
    value: 'lecture'
  },
  {
    text: 'Lecture Online',
    value: 'lectureOnline'
  },
  {
    text: 'Lecture Offline',
    value: 'lectureOffline'
  },
  {
    text: 'Lecture Mixed',
    value: 'lectureMixed'
  },
  {
    text: 'Lecture Self Study',
    value: 'lectureSelfStudy'
  },
  {
    text: 'Test',
    value: 'test'
  },
  {
    text: 'Info',
    value: 'info'
  },
  {
    text: 'Warmup',
    value: 'warmup'
  },
  {
    text: 'Meetup',
    value: 'meetup'
  },
  {
    text: 'Workshop',
    value: 'workshop'
  },
  {
    text: 'Interview',
    value: 'interview'
  }
];
